

import React from 'react';
import './ActionItemListItem.css';

export default function ActionItemListItemMessage({message}) 
{
    return (
        <>
            <li class="list-group-item list-group-item-action">
                <input class="form-check-input me-1" type="checkbox" value="" id="firstCheckbox"/>
                <label class="form-check-label" htmlFor="firstCheckbox">
                    <img class="action-item-icon" src="./images/on-fire.svg" alt="On-Fire" border="0"/>
                    {message} 
                </label>            
            </li>
        </>
    );
}
